import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogs } from "../../features/blogs/blogsSlice";
import Blog from "./Blog";

export default function BlogsGrid() {
  const dispatch = useDispatch();
  const { blogs, error, isLoading } = useSelector((state) => state.blogs);
  const filters = useSelector((state) => state.filters);
  useEffect(() => {
    dispatch(fetchBlogs());
  }, [dispatch]);
  return (
    <main className="post-container" id="lws-postContainer">
      {isLoading ? (
        <p>Loading...</p>
      ) : error ? (
        error
      ) : (
        blogs
          .filter((blog) => {
            if (filters.filter === "saved") {
              return blog.isSaved;
            } else {
              return true;
            }
          })
          .sort((a, b) => {
            if (filters.sort === "newest") {
              const dateA = new Date(a.createdAt);
              const dateB = new Date(b.createdAt);
              return dateB - dateA;
            } else if (filters.sort === "most_liked") {
              return b.likes - a.likes;
            } else {
              return true;
            }
          })
          .map((blog) => {
            return <Blog key={blog.id} blog={blog} />;
          })
      )}
    </main>
  );
}
